import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "./Logo";
import { Footer } from "./Footer";
import { Seo } from "./Seo";

export const PolicySection = ({ title, children }) => (
  <section>
    <h2 className="font-display text-2xl font-medium tracking-tight text-crave-cream">{title}</h2>
    <div className="mt-3 space-y-3 text-base leading-relaxed text-crave-muted">{children}</div>
  </section>
);

export const PolicyLayout = ({ testId, seoTitle, seoDescription, seoPath, title, updated, children }) => (
  <div className="min-h-screen bg-crave-bg text-crave-cream">
    <Seo title={seoTitle} description={seoDescription} path={seoPath} />
    <header className="border-b border-crave-border">
      <div className="mx-auto flex max-w-4xl items-center justify-between px-6 py-6">
        <Logo testId={`${testId}-logo`} />
        <Link
          to="/"
          data-testid={`${testId}-back-link`}
          className="flex items-center gap-2 text-sm font-medium text-crave-muted transition-colors duration-300 hover:text-crave-gold"
        >
          <ArrowLeft className="h-4 w-4" aria-hidden="true" />
          Back to home
        </Link>
      </div>
    </header>
    <main className="mx-auto max-w-4xl px-6 py-16 md:py-24" data-testid={testId}>
      <p className="text-xs font-bold uppercase tracking-[0.28em] text-crave-gold">Foodie Crave</p>
      <h1 className="mt-4 font-display text-4xl font-medium tracking-tight text-crave-cream sm:text-5xl">
        {title}
      </h1>
      <p className="mt-4 text-sm text-crave-muted">Last updated: {updated}</p>
      <div className="mt-12 space-y-10">{children}</div>
    </main>
    <Footer />
  </div>
);
